import React from "react";
import { ReactComponent as WeatherArrowIcon } from "./../../images/svg/weatherArrow.svg";
import { ReactComponent as TemperatureIcon } from "./../../images/svg/temperature.svg";
import { ReactComponent as SunnyIcon } from "./../../images/svg/sunny.svg";
import { ReactComponent as CloudyIcon } from "./../../images/svg/cloudy.svg";
import { ReactComponent as CloudyHeavyRainIcon } from "./../../images/svg/cloudyHeavyRain.svg";
import { ReactComponent as CloudyLightRainIcon } from "./../../images/svg/cloudyLightRain.svg";
import { ReactComponent as PartlyCloudyHeavyRainIcon } from "./../../images/svg/partlyCloudyHeavyRain.svg";
import { ReactComponent as PartlyCloudyLightRainIcon } from "./../../images/svg/partlyCloudyLightRain.svg";
import { ReactComponent as PartlyCloudyIcon } from "./../../images/svg/partlyCloudy.svg";
import { cropr, gettext } from "../../adapter";

const renderWeatherIcon = (descriptor) => {
  switch (descriptor) {
    case "CLOUDY_LIGHT_RAIN":
      return <CloudyLightRainIcon className="weather--precipitation" />;
    case "PARTLY_CLOUDY_LIGHT_RAIN":
      return <PartlyCloudyLightRainIcon className="weather--precipitation" />;
    case "PARTLY_CLOUDY":
      return <PartlyCloudyIcon className="weather--precipitation" />;
    case "PARTLY_CLOUDY_HEAVY_RAIN":
      return <PartlyCloudyHeavyRainIcon className="weather--precipitation" />;
    case "CLOUDY":
      return <CloudyIcon className="weather--precipitation" />;
    case "CLOUDY_HEAVY_RAIN":
      return <CloudyHeavyRainIcon className="weather--precipitation" />;
    case "SUNNY":
      return <SunnyIcon className="weather--precipitation" />;
    default:
      return null;
  }
};

const DayPart = ({ forecast }) => {
  var hourShort = gettext("h");

  var hour = <span>&nbsp;</span>;
  if (forecast.hour !== 0) {
    hour = (
      <span>
        {forecast.hour}
        {hourShort}
      </span>
    );
  }

  var rotation = {
    msTransform: "rotate(" + forecast.windDirection + "deg)",
    WebkitTransform: "rotate(" + forecast.windDirection + "deg)",
    transform: "rotate(" + forecast.windDirection + "deg)",
  };

  var humidity = "";
  var sprayingConditions = "";
  var precision = cropr.l10n.unit_precipitation === "in" ? 2 : 1;

  humidity = (
    <div className="weather--humidity">
      {gettext("RH")}: <strong>{cropr.toLocaleFixed(forecast.minimumHumidity, 0)}%</strong>
    </div>
  );

  return (
    <li>
      <div className="weather--time">{hour}</div>
      {renderWeatherIcon(forecast.descriptor)}
      <span className="weather--precipitation-chance">{forecast.precipitationChance}%</span>
      <span className="weather--precipitation-amount">
        {cropr.toLocaleFixed(forecast.precipitationAmount, precision)}{" "}
        {cropr.l10n.unit_precipitation_display}
      </span>

      <TemperatureIcon className="weather--temperature" />
      <span className="weather--temperature-high">
        {cropr.toLocaleFixed(forecast.maximumTemperature, 1)}
        {cropr.l10n.unit_temp_display}
      </span>
      <span className="weather--temperature-low">
        {cropr.toLocaleFixed(forecast.minimumTemperature, 1)}
        {cropr.l10n.unit_temp_display}
      </span>

      <div className="weather--wind">
        {cropr.toLocaleFixed(forecast.windSpeed)} {cropr.l10n.unit_windspeed_display}
        <WeatherArrowIcon style={rotation} className="weather--arrow" />
      </div>

      {humidity}
      {sprayingConditions}
    </li>
  );
};

export default DayPart;
